/** Lowercase keys used after normalizeRegionKey */
const REGION_OR_STATE_FULL_NAME_TO_ABBR: Record<string, string> = {
	// United States
	alabama: 'AL',
	alaska: 'AK',
	arizona: 'AZ',
	arkansas: 'AR',
	california: 'CA',
	colorado: 'CO',
	connecticut: 'CT',
	delaware: 'DE',
	florida: 'FL',
	georgia: 'GA',
	hawaii: 'HI',
	idaho: 'ID',
	illinois: 'IL',
	indiana: 'IN',
	iowa: 'IA',
	kansas: 'KS',
	kentucky: 'KY',
	louisiana: 'LA',
	maine: 'ME',
	maryland: 'MD',
	massachusetts: 'MA',
	michigan: 'MI',
	minnesota: 'MN',
	mississippi: 'MS',
	missouri: 'MO',
	montana: 'MT',
	nebraska: 'NE',
	nevada: 'NV',
	'new hampshire': 'NH',
	'new jersey': 'NJ',
	'new mexico': 'NM',
	'new york': 'NY',
	'north carolina': 'NC',
	'north dakota': 'ND',
	ohio: 'OH',
	oklahoma: 'OK',
	oregon: 'OR',
	pennsylvania: 'PA',
	'rhode island': 'RI',
	'south carolina': 'SC',
	'south dakota': 'SD',
	tennessee: 'TN',
	texas: 'TX',
	utah: 'UT',
	vermont: 'VT',
	virginia: 'VA',
	washington: 'WA',
	'west virginia': 'WV',
	wisconsin: 'WI',
	wyoming: 'WY',
	'district of columbia': 'DC',

	// Canada — provinces & territories
	alberta: 'AB',
	'british columbia': 'BC',
	manitoba: 'MB',
	'new brunswick': 'NB',
	'newfoundland and labrador': 'NL',
	'northwest territories': 'NT',
	'nova scotia': 'NS',
	nunavut: 'NU',
	ontario: 'ON',
	'prince edward island': 'PE',
	quebec: 'QC',
	saskatchewan: 'SK',
	yukon: 'YT',
}

function normalizeRegionKey(value: string): string {
	return value
		.trim()
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\s+/g, ' ')
}

/**
 * Returns a postal abbreviation when `region` is a known US state or Canadian
 * province/territory name; otherwise returns the original string unchanged.
 * Two-letter values are uppercased (already abbreviated codes).
 */
export function abbreviateRegion(region: string | null | undefined): string {
	if (region == null || region === '') return ''

	const trimmed = region.trim()
	if (/^[a-z]{2}$/i.test(trimmed)) return trimmed.toUpperCase()

	const key = normalizeRegionKey(trimmed)
	return REGION_OR_STATE_FULL_NAME_TO_ABBR[key] ?? trimmed
}
